import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'order',
  pure: false,
})
export class OrderPipe implements PipeTransform {
  transform(items: any[], order: string): any[] {
    if (!items || !order) {
      return [];
    }
    items.sort(function (a, b) {
      // Compare the 2 dates
      if (a[order] < b[order]) {
        return -1;
      }
      if (a[order] > b[order]) {
        return 1;
      }
      return 0;
    });
    return items;
  }
}
